import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { AppState } from 'src';
import { history } from 'src';

import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { OptionsViewModel } from '@models/common.models';
import { VendorViewModel } from '@models/Vendor';

import { ReviewStepComponentProperties, ReviewStepComponent } from './review-step.component';
import { saveVendor, SaveVendorSuccessAction } from '../../../../vendor.actions';
import { DynamicSelectIdentifier } from '../../../../../common/components/dynamic-select/dynamic-select-types';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: { buttonRef: (button: HTMLButtonElement) => void; next: Function; currentStep: number; jump: Function }
): Partial<ReviewStepComponentProperties> {
  return {
    vendorVM: state.vendor.vendorVM,
    buttonRef: ownProps.buttonRef,
    saving: state.vendor.saving,
    w9StatusOptions:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorW9Statuses] || ([] as Array<OptionsViewModel>),
    vendorTypeOptions:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorTypes] || ([] as Array<OptionsViewModel>),
    vendorGroupOptions:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorGroups] || ([] as Array<OptionsViewModel>),
    vendorStatusOptions:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorStatuses] || ([] as Array<OptionsViewModel>),
    agreementTypeOptions:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorAgreementTypes] || ([] as Array<OptionsViewModel>)
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { buttonRef: (button: HTMLButtonElement) => void; next?: Function; jump: Function }
): Partial<ReviewStepComponentProperties> {
  return {
    onSaveClick: (model: VendorViewModel) => {
      dispatch(saveVendor(model)).then(svsa =>
        history.push(getRoute(RouteDefinitions.vendor.Details, { id: (svsa as SaveVendorSuccessAction).createdID }))
      );
    },
    jump: step => {
      ownProps.jump(step);
    }
  };
}
/*
  ;
*/

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ReviewStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewStepComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/review/review-step.container.ts